import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Row,
  Form,
  Modal,
  Col,
  List,
  App,
  Popconfirm,
} from "antd";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "antd/es/form/Form";
import { saveCustomerGroup } from "../../../services/customer";

import {
  fetchCustomersGroupList,
  fetchGroupCustomers,
  updateCustomerListGroup,
  deleteCustomerGroup,
} from "../customersThunks";

import InputField from "../../../components/Input/Input";
import { getAccessType } from "../../../lib/functions";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useIsAdminUser } from "../../../lib/accessList";
import "./customer.css";

const CustomersGroupList = ({ customersGroupList }) => {
  const { modal, message } = App.useApp();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, groupedPendingCustomers, groupedSelectedCustomers } =
    useSelector((state) => state.customers);
  const authInfo = useSelector((state) => state.auth?.auth_info);
  const canEdit = authInfo?.can_edit === 1;
  const canDelete = authInfo?.can_delete === 1;

  console.log(canEdit, canDelete, "canDelete");
  const isAdminUser = useIsAdminUser();

  const [groupModalOpen, setGroupModalOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editGroupId, setEditGroupId] = useState(0);

  const [selectedGroupId, setSelectedGroupId] = useState(null);
  let [access_type, access_type_set] = useState("");

  useEffect(() => {
    const access = getAccessType("customer_entry");
    access_type_set(access);
  }, []);

  const [form] = useForm();

  useEffect(() => {
    dispatch(fetchCustomersGroupList());
  }, [dispatch]);

  const columns = [
    {
      title: "NO.",
      dataIndex: "id",
      width: 100,
      render: (_, __, index) => index + 1,
    },
    {
      title: "Group Name",
      dataIndex: "name",
      width: 200,
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    ...(access_type === "WRITE"
      ? [
        {
          title: "Actions",
          render: (_, record) => (
            <>
              <Button
                type="link"
                disabled={!(isAdminUser || canEdit)}
                onClick={(e) => {
                  e.stopPropagation(); // prevent row click
                  form.setFieldsValue(record);
                  setIsEdit(true);
                  setEditGroupId(record.id);
                }}
                icon={<EditOutlined />}
              />

              <Popconfirm
                title="Delete this group?"
                onConfirm={(e) => {
                  e?.stopPropagation();
                  handleDelete(record.id);
                }}
                onCancel={(e) => e?.stopPropagation()}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  type="link"
                  danger
                  disabled={!(isAdminUser || canDelete)}
                  onClick={(e) => e.stopPropagation()} // prevent row click
                  icon={<DeleteOutlined />}
                />
              </Popconfirm>
            </>
          ),
        }] : [])
  ];

  const handleDelete = async (acc_id) => {
    try {
      const res = await dispatch(deleteCustomerGroup({ id: acc_id }));

      if (res?.payload && !res.payload.error) {
        message.success(res.payload.msg || "Group deleted successfully");
        dispatch(fetchCustomersGroupList());
      } else {
        message.error(res.payload?.msg || "Failed to delete group");
      }
    } catch (error) {
      console.error("Delete failed:", error);
      message.error("Error while deleting group");
    }
  };

  const handleSave = async (value) => {
    const payload = {
      action: isEdit ? "update" : "create",
      id: editGroupId,
      name: value.name,
    };
    try {
      const res = await saveCustomerGroup(payload);
      dispatch(fetchCustomersGroupList());
      form.setFieldsValue({ name: undefined });
      setIsEdit(false);
      setEditGroupId(0);
      modal.success({
        title: res.data?.msg,
        content: "",
      });
    } catch (error) {
      console.log("error--->", error);
    }
  };

  const handleRowClick = async (record) => {
    await dispatch(fetchGroupCustomers(record.id));
    setSelectedGroupId(record.id);
    setGroupModalOpen(true);
  };

  const handleAssign = async (acc_id) => {
    try {
      await dispatch(
        updateCustomerListGroup({
          acc_id: acc_id,
          customer_group_id: selectedGroupId,
        })
      );
      await dispatch(fetchGroupCustomers(selectedGroupId));
      message.success("Customer assigned successfully");
    } catch {
      message.error("Failed to assign customer");
    }
  };

  const handleUnassign = async (acc_id) => {
    try {
      await dispatch(
        updateCustomerListGroup({
          acc_id,
          customer_group_id: null,
        })
      );
      await dispatch(fetchGroupCustomers(selectedGroupId));
      message.success("Customer removed from group");
    } catch {
      message.error("Failed to remove customer");
    }
  };

  return (
    <>
      <Row style={{ marginBottom: "32px", marginTop: "32px", width: "100%" }}>
        <Form
          form={form}
          layout="inline"
          onFinish={handleSave}
          initialValues={{}}
          variant="filled"
          style={{ maxWidth: "1400px", width: "100%" }}
          className="responsive-form customer-group-form"
          colon={false}
        >
          <Form.Item
            label="Group Name"
            name="name"
            rules={[{ required: true, message: "Group Name is Required" }]}
          >
            <InputField />
          </Form.Item>
          <Form.Item>
            {access_type == "WRITE" && <>
              <Button type="primary" htmlType="submit" className="traic-button">
                Add
              </Button>
            </>}
          </Form.Item>
        </Form>
      </Row>
      <Table
        loading={loading}
        columns={columns}
        dataSource={customersGroupList || []}
        rowKey={(record) => record.id}
        onRow={(record) => ({
          onClick: () => handleRowClick(record),
        })}
        style={{ cursor: "pointer" }}
      />
      <Modal
        title="Customers in this Group"
        open={groupModalOpen}
        onCancel={() => {
          setGroupModalOpen(false);
          setSelectedGroupId(null);
        }}
        footer={null}
        width={700}
      >
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <h3>Available Customers</h3>
            <List
              bordered
              dataSource={groupedPendingCustomers || []}
              locale={{ emptyText: "No available customers" }}
              renderItem={(item) => (
                <List.Item
                  key={item.acc_id}
                  style={{ cursor: "pointer" }}
                  onClick={() => handleAssign(item.acc_id)}
                >
                  {item.acc_name}
                </List.Item>
              )}
            />
          </Col>
          <Col xs={24} sm={12}>
            <h3>Selected Customers</h3>
            <List
              bordered
              dataSource={groupedSelectedCustomers || []}
              locale={{ emptyText: "No customers in this group" }}
              renderItem={(item) => (
                <List.Item
                  key={item.acc_id}
                  style={{ cursor: "pointer" }}
                  onClick={() => handleUnassign(item.acc_id)}
                >
                  {item.acc_name}
                </List.Item>
              )}
            />
          </Col>
        </Row>
      </Modal>

    </>
  );
};

export default CustomersGroupList;
